import { render, staticRenderFns } from "./FeatureTourCmp.vue?vue&type=template&id=6b1c317f&scoped=true&"
import script from "./FeatureTourCmp.vue?vue&type=script&lang=js&"
export * from "./FeatureTourCmp.vue?vue&type=script&lang=js&"
import style0 from "./FeatureTourCmp.vue?vue&type=style&index=0&id=6b1c317f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c317f",
  null
  
)

export default component.exports